import { useMediaQuery } from "@mui/material";

const usePlatform = () => {
  const isBreakPoint = useMediaQuery("(min-width:1000px)");

  return {
    isPc: isBreakPoint,
    isMobile: !isBreakPoint,
  };
};

export default usePlatform;
